import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=5813a854&scoped=true"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=5813a854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813a854",
  null
  
)

export default component.exports